import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const ServicesBreadcrumb = ({ 
  serviceCategory = 'Services',
  serviceName = '',
  className = '' 
}) => {
  const location = useLocation();

  const breadcrumbItems = [
    { label: 'Home', path: '/home' },
    { label: serviceCategory, path: '/services' },
  ];

  if (serviceName) {
    breadcrumbItems?.push({ label: serviceName, path: location?.pathname });
  }

  return (
    <nav 
      className={`z-breadcrumb bg-background/50 backdrop-blur-sm border-b border-border ${className}`}
      aria-label="Breadcrumb"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center py-4">
          <ol className="flex items-center space-x-2 text-sm">
            {breadcrumbItems?.map((item, index) => (
              <li key={item?.path} className="flex items-center">
                {index > 0 && (
                  <Icon 
                    name="ChevronRight" 
                    size={16} 
                    className="text-muted-foreground mx-2" 
                  />
                )}
                
                {index === breadcrumbItems?.length - 1 ? (
                  <span 
                    className="text-accent font-medium"
                    aria-current="page"
                  >
                    {item?.label}
                  </span>
                ) : (
                  <Link
                    to={item?.path}
                    className="text-text-secondary hover:text-accent transition-colors duration-200 focus-ring rounded px-2 py-1"
                  >
                    {item?.label}
                  </Link>
                )}
              </li>
            ))}
          </ol>
        </div>
      </div>
    </nav>
  );
};

export default ServicesBreadcrumb;